(function () {
  function setText(selector, value) {
    var el = document.querySelector(selector);
    if (el) el.textContent = value;
  }

  function closeOverlay(overlay, search, cart) {
    if (overlay) overlay.classList.remove('open');
    if (search) search.classList.remove('open');
    if (cart) cart.classList.remove('open');
  }

  function initCountdown() {
    var h = 12;
    var m = 34;
    var s = 56;

    function tick() {
      var hEl = document.querySelector('[data-h]');
      if (!hEl) return;
      setText('[data-h]', String(h).padStart(2, '0'));
      setText('[data-m]', String(m).padStart(2, '0'));
      setText('[data-s]', String(s).padStart(2, '0'));

      if (s > 0) s -= 1;
      else if (m > 0) {
        m -= 1;
        s = 59;
      } else if (h > 0) {
        h -= 1;
        m = 59;
        s = 59;
      }
    }

    tick();
    setInterval(tick, 1000);
  }

  function initFaq() {
    document.querySelectorAll('[data-faq]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.faq-card');
        if (!card) return;
        card.classList.toggle('open');
      });
    });
  }

  function initGallery() {
    var mainImageWrap = document.querySelector('.main-product-image');
    var mainImg = document.querySelector('[data-main-img]');
    var thumbRow = document.querySelector('.thumb-row');
    var thumbButtons = Array.from(document.querySelectorAll('[data-thumb]'));
    if (!mainImg || !thumbButtons.length || !mainImageWrap) return;

    var currentIndex = Math.max(0, thumbButtons.findIndex(function (btn) { return btn.classList.contains('active'); }));
    if (currentIndex < 0) currentIndex = 0;

    function syncThumbRailHeight() {
      if (!mainImg || !thumbRow) return;
      if (window.matchMedia('(max-width: 900px)').matches) {
        thumbRow.style.maxHeight = '';
        thumbRow.style.setProperty('--thumb-size', '');
        return;
      }

      var mainHeight = mainImg.getBoundingClientRect().height;
      if (mainHeight <= 0) return;

      var gap = 12;
      var count = thumbButtons.length;
      var maxThumbSize = 92;
      var minThumbSize = 56;
      var computedSize = Math.floor((mainHeight - gap * (count - 1)) / count);
      var thumbSize = Math.max(minThumbSize, Math.min(maxThumbSize, computedSize));

      thumbRow.style.maxHeight = Math.round(mainHeight) + 'px';
      thumbRow.style.setProperty('--thumb-size', thumbSize + 'px');
    }

    function setActiveImage(index) {
      if (!thumbButtons.length) return;
      currentIndex = Math.max(0, Math.min(index, thumbButtons.length - 1));
      var targetBtn = thumbButtons[currentIndex];
      if (!targetBtn) return;

      var nextSrc = targetBtn.dataset.thumb;
      if (nextSrc) {
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = nextSrc;
      }

      var thumbImg = targetBtn.querySelector('img');
      if (thumbImg && thumbImg.alt) mainImg.alt = thumbImg.alt;

      thumbButtons.forEach(function (btn, i) {
        btn.classList.toggle('active', i === currentIndex);
      });

      syncThumbRailHeight();
    }

    function goToNext() {
      if (currentIndex < thumbButtons.length - 1) setActiveImage(currentIndex + 1);
    }

    function goToPrev() {
      if (currentIndex > 0) setActiveImage(currentIndex - 1);
    }

    function updateImageSideCursor(event) {
      if (window.matchMedia('(max-width: 900px)').matches || thumbButtons.length <= 1) {
        mainImageWrap.classList.remove('gallery-cursor-prev');
        mainImageWrap.classList.remove('gallery-cursor-next');
        return;
      }

      var rect = mainImageWrap.getBoundingClientRect();
      var offsetX = event.clientX - rect.left;
      var isRightSide = offsetX >= rect.width / 2;
      mainImageWrap.classList.toggle('gallery-cursor-next', isRightSide);
      mainImageWrap.classList.toggle('gallery-cursor-prev', !isRightSide);
    }

    function clearImageSideCursor() {
      mainImageWrap.classList.remove('gallery-cursor-prev');
      mainImageWrap.classList.remove('gallery-cursor-next');
    }

    if (mainImg.complete) syncThumbRailHeight();
    mainImg.addEventListener('load', syncThumbRailHeight);
    window.addEventListener('resize', syncThumbRailHeight);

    thumbButtons.forEach(function (btn, index) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        setActiveImage(index);
      });
    });

    mainImageWrap.addEventListener('mousemove', updateImageSideCursor);
    mainImageWrap.addEventListener('mouseenter', updateImageSideCursor);
    mainImageWrap.addEventListener('mouseleave', clearImageSideCursor);

    mainImageWrap.addEventListener('click', function (event) {
      if (thumbButtons.length <= 1 || window.matchMedia('(max-width: 900px)').matches) return;
      if (event.target && event.target.closest && event.target.closest('.product-float-actions')) return;
      var rect = mainImageWrap.getBoundingClientRect();
      var offsetX = event.clientX - rect.left;
      if (offsetX >= rect.width / 2) goToNext();
      else goToPrev();
    });

    mainImageWrap.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        goToNext();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goToPrev();
      }
    });

    mainImageWrap.setAttribute('tabindex', '0');
    setActiveImage(currentIndex);
  }

  function initShare() {
    var shareBtn = document.querySelector('[data-share-product]');
    if (!shareBtn) return;

    shareBtn.addEventListener('click', async function () {
      var shareUrl = window.location.href;
      var title = (document.querySelector('.title-1') || {}).textContent || document.title;
      var shareData = { title: title, text: 'Check out ' + title, url: shareUrl };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (e) {
          if (e && e.name === 'AbortError') return;
        }
      }

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(shareUrl);
          alert('Product link copied.');
        }
      } catch (e) {
        window.prompt('Copy this product link:', shareUrl);
      }
    });
  }

  function initQty() {
    var qty = 1;
    var qtyEl = document.querySelector('[data-qty]');
    var qtyInput = document.querySelector('[data-qty-input]');
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (!qtyEl || !minus || !plus) return;

    minus.addEventListener('click', function () {
      qty = Math.max(1, qty - 1);
      qtyEl.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
    });

    plus.addEventListener('click', function () {
      qty += 1;
      qtyEl.textContent = String(qty);
      if (qtyInput) qtyInput.value = String(qty);
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-overlay]');
    var itemsWrap = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var checkoutTotalEl = document.querySelector('[data-cart-checkout-total]');
    var footerFilled = document.querySelector('[data-cart-footer-filled]');
    var footerEmpty = document.querySelector('[data-cart-footer-empty]');
    var recommendationsBlock = document.querySelector('[data-cart-recommendations-block]');
    var recommendationItems = Array.from(document.querySelectorAll('[data-recommendation-product-id]'));
    if (!drawer || !itemsWrap || !subtotalEl) return;

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function escapeAttr(value) {
      return escapeHtml(value).replace(/`/g, '&#96;');
    }

    function formatMoney(cents, currencyCode) {
      var value = (Number(cents) || 0) / 100;
      try {
        var formatted = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: currencyCode || 'INR',
          maximumFractionDigits: 2,
        }).format(value);
        return formatted.replace(/\.00\b/, '');
      } catch (e) {
          return 'Rs. ' + value.toFixed(2).replace(/\.00$/, '');
      }
    }

    function setCartCounts(count) {
      document.querySelectorAll('[data-cart-count], [data-cart-drawer-count]').forEach(function (el) {
        el.textContent = String(count || 0);
      });
    }

    function proceedToCheckoutWithOldService(triggerEl) {
      if (window.zecpeCheckFunctionAndCall) {
        window.zecpeCheckFunctionAndCall('handleOcc', triggerEl || null);
        return;
      }
      window.location.href = '/cart/checkout';
    }

    function isCheckoutIntent(event, form) {
      var submitter = event.submitter;
      if (!submitter && document.activeElement && form.contains(document.activeElement)) {
        submitter = document.activeElement;
      }
      if (!submitter) return false;

      var submitterName = (submitter.getAttribute('name') || '').toLowerCase();
      if (submitterName === 'checkout') return true;
      if (submitter.classList && submitter.classList.contains('product-buy-btn')) return true;

      var submitterText = (submitter.textContent || '').toLowerCase();
      return submitterText.indexOf('buy now') !== -1;
    }

    function propertiesHtml(item) {
      var html = '';
      if (item.variant_title && item.variant_title !== 'Default Title') {
        html += '<span class="product-item-meta__property text--subdued text--xsmall">' + escapeHtml(item.variant_title) + '</span>';
      }

      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name) {
        html += '<span class="product-item-meta__property text--subdued text--xsmall">' + escapeHtml(item.selling_plan_allocation.selling_plan.name) + '</span>';
      }

      if (item.properties && typeof item.properties === 'object') {
        var keys = Object.keys(item.properties);
        var rows = [];
        keys.forEach(function (key) {
          var value = item.properties[key];
          if (!key || key.charAt(0) === '_' || value == null || String(value).trim() === '') return;
          rows.push('<li>' + escapeHtml(key) + ': ' + escapeHtml(String(value)) + '</li>');
        });
        if (rows.length > 0) {
          html += '<ul class="product-item-meta__property list--unstyled text--subdued text--xsmall" role="list">' + rows.join('') + '</ul>';
        }
      }

      if (!html) return '';
      return '<div class="product-item-meta__property-list">' + html + '</div>';
    }

    function lineDiscountsHtml(item, currency) {
      var discounts = item.line_level_discount_allocations;
      if (!Array.isArray(discounts) || discounts.length === 0) return '';

      var rows = discounts.map(function (discount) {
        var title = escapeHtml((discount.discount_application && discount.discount_application.title) || 'Discount');
        var amount = formatMoney(discount.amount || 0, currency);
        return '<li class="line-item__discount-badge">' + title + ' (-' + amount + ')</li>';
      });

      return '<ul class="line-item__discount-list list--unstyled" role="list">' + rows.join('') + '</ul>';
    }

    function itemHtml(item, currency) {
      var itemKey = escapeAttr(item.key);
      var title = escapeHtml(item.product_title || item.title || 'Product');
      var properties = propertiesHtml(item);
      var image = '';
      if (item.image) {
        image = '<img class="line-item__image" src="' + escapeAttr(item.image) + '" alt="' + title + '">';
      }
      var compare = '';
      if ((Number(item.original_line_price) || 0) > (Number(item.final_line_price) || 0)) {
        compare = '<span class="price price--compare">' + formatMoney(item.original_line_price, currency) + '</span>';
      }
      var lineDiscounts = lineDiscountsHtml(item, currency);

      return (
        '<line-item class="line-item" data-cart-item-key="' + itemKey + '">' +
          '<div class="line-item__content-wrapper">' +
            '<a href="' + escapeAttr(item.url || '#') + '" class="line-item__image-wrapper" tabindex="-1" aria-hidden="true">' +
              image +
            '</a>' +
            '<div class="line-item__info">' +
              '<div class="product-item-meta">' +
                '<a href="' + escapeAttr(item.url || '#') + '" class="product-item-meta__title text--small">' + title + '</a>' +
                properties +
                '<div class="price-list text--small">' +
                  '<span class="price">' + formatMoney(item.final_line_price, currency) + '</span>' +
                  compare +
                '</div>' +
              '</div>' +
              lineDiscounts +
              '<line-item-quantity class="line-item__quantity">' +
                '<div class="quantity-selector quantity-selector--small">' +
                  '<button type="button" class="quantity-selector__button" data-cart-decrease="' + itemKey + '" aria-label="Decrease quantity">-</button>' +
                  '<input class="quantity-selector__input text--xsmall" type="text" value="' + String(item.quantity || 0) + '" data-cart-quantity readonly>' +
                  '<button type="button" class="quantity-selector__button" data-cart-increase="' + itemKey + '" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button class="line-item__remove-button link text--subdued text--xxsmall" type="button" data-cart-remove="' + itemKey + '" aria-label="Remove item">Remove</button>' +
              '</line-item-quantity>' +
            '</div>' +
          '</div>' +
        '</line-item>'
      );
    }

    function renderCart(cart) {
      if (!cart || !Array.isArray(cart.items)) return;
      if (cart.items.length === 0) {
        itemsWrap.innerHTML = '<p class="muted" data-cart-empty>Your cart is empty.</p>';
      } else {
        itemsWrap.innerHTML = cart.items.map(function (item) {
          return itemHtml(item, cart.currency);
        }).join('');
      }

      subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
      if (checkoutTotalEl) checkoutTotalEl.textContent = formatMoney(cart.total_price, cart.currency);
      if (footerFilled && footerEmpty) {
        var hasItems = (cart.item_count || 0) > 0;
        footerFilled.hidden = !hasItems;
        footerEmpty.hidden = hasItems;
      }
      setCartCounts(cart.item_count || 0);
      syncRecommendations(cart);
    }

    function syncRecommendations(cart) {
      if (!recommendationsBlock || recommendationItems.length === 0) return;

      var inCartProductIds = {};
      (cart.items || []).forEach(function (item) {
        if (item && item.product_id != null) {
          inCartProductIds[String(item.product_id)] = true;
        }
      });

      var visibleCount = 0;
      recommendationItems.forEach(function (itemEl) {
        var productId = itemEl.getAttribute('data-recommendation-product-id') || '';
        var shouldHide = !!inCartProductIds[productId];
        itemEl.hidden = shouldHide;
        if (!shouldHide) visibleCount += 1;
      });

      recommendationsBlock.hidden = (cart.item_count || 0) === 0 || visibleCount === 0;
    }

    function openCartDrawer() {
      if (overlay) overlay.classList.add('open');
      drawer.classList.add('open');
      var navEl = document.getElementById('nav');
      if (navEl) navEl.classList.remove('menu-open');
    }

    async function fetchCartAndRender() {
      var res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('Failed to fetch cart');
      var cart = await res.json();
      renderCart(cart);
      return cart;
    }

    async function changeLineItem(key, quantity) {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });

      if (!res.ok) throw new Error('Failed to update cart');
      var cart = await res.json();
      renderCart(cart);
      return cart;
    }

    itemsWrap.addEventListener('click', async function (event) {
      var decBtn = event.target.closest('[data-cart-decrease]');
      var incBtn = event.target.closest('[data-cart-increase]');
      var removeBtn = event.target.closest('[data-cart-remove]');
      if (!decBtn && !incBtn && !removeBtn) return;
      event.preventDefault();

      var key = '';
      var currentQty = 1;
      if (decBtn) {
        key = decBtn.getAttribute('data-cart-decrease') || '';
        var decQtyInput = decBtn.parentElement ? decBtn.parentElement.querySelector('[data-cart-quantity]') : null;
        currentQty = Number(decQtyInput ? decQtyInput.value : 1) || 1;
      } else if (incBtn) {
        key = incBtn.getAttribute('data-cart-increase') || '';
        var incQtyInput = incBtn.parentElement ? incBtn.parentElement.querySelector('[data-cart-quantity]') : null;
        currentQty = Number(incQtyInput ? incQtyInput.value : 1) || 1;
      } else if (removeBtn) {
        key = removeBtn.getAttribute('data-cart-remove') || '';
      }
      if (!key) return;

      try {
        if (removeBtn) {
          await changeLineItem(key, 0);
          return;
        }
        if (decBtn) {
          await changeLineItem(key, Math.max(0, currentQty - 1));
          return;
        }
        if (incBtn) {
          await changeLineItem(key, currentQty + 1);
        }
      } catch (e) {
        console.error(e);
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', async function (event) {
        var checkoutIntent = isCheckoutIntent(event, form);

        if (checkoutIntent) {
          event.preventDefault();
          try {
            var checkoutFormData = new FormData(form);
            var checkoutAddRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: checkoutFormData,
            });
            if (!checkoutAddRes.ok) throw new Error('Failed to add buy-now item');
            proceedToCheckoutWithOldService(event.submitter || form.querySelector('[name="checkout"]') || form);
          } catch (e) {
            console.error(e);
            form.submit();
          }
          return;
        }

        event.preventDefault();

        try {
          var formData = new FormData(form);
          var addRes = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: formData,
          });
          if (!addRes.ok) throw new Error('Failed to add to cart');

          await fetchCartAndRender();
          openCartDrawer();
        } catch (e) {
          console.error(e);
          form.submit();
        }
      });
    });

    fetchCartAndRender().catch(function () {
      // Keep server-rendered cart if fetch fails.
    });
  }

  function initReviewForm() {
    var reviewForm = document.querySelector('[data-review-form]');
    var reviewToggle = document.querySelector('[data-toggle-review-form]');
    var reviewContent = document.querySelector('#review-content');

    function autoGrowReview() {
      if (!reviewContent) return;
      reviewContent.style.height = 'auto';
      reviewContent.style.height = reviewContent.scrollHeight + 'px';
    }

    if (reviewContent) reviewContent.addEventListener('input', autoGrowReview);

    if (reviewToggle) {
      reviewToggle.addEventListener('click', function () {
        if (!reviewForm) return;
        reviewForm.hidden = false;
        reviewForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        autoGrowReview();
        var titleField = reviewForm.querySelector('#review-title');
        if (titleField) titleField.focus();
      });
    }

    var cancelBtn = document.querySelector('[data-cancel-review]');
    if (cancelBtn) {
      cancelBtn.addEventListener('click', function () {
        if (!reviewForm) return;
        reviewForm.reset();
        if (reviewContent) reviewContent.style.height = '';
        reviewForm.hidden = true;
      });
    }

    if (reviewForm) {
      reviewForm.addEventListener('submit', function (event) {
        event.preventDefault();
        alert('Thanks! Your review has been submitted.');
        reviewForm.reset();
        if (reviewContent) reviewContent.style.height = '';
        reviewForm.hidden = true;
      });
    }
  }

  function initProductTabs() {
    var tabButtons = document.querySelectorAll('[data-products-tab]');
    var tabPanels = document.querySelectorAll('[data-products-panel]');
    if (!tabButtons.length || !tabPanels.length) return;

    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tab = btn.getAttribute('data-products-tab');
        if (!tab) return;

        tabButtons.forEach(function (button) {
          button.classList.remove('btn-dark');
          if (!button.classList.contains('btn-soft')) button.classList.add('btn-soft');
        });
        btn.classList.add('btn-dark');
        btn.classList.remove('btn-soft');

        tabPanels.forEach(function (panel) {
          panel.classList.toggle('active', panel.getAttribute('data-products-panel') === tab);
        });
      });
    });
  }

  function initDealsCarousel() {
    var carousels = document.querySelectorAll('[data-deals-carousel]');
    if (!carousels.length) return;

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-deals-track]');
      var prevBtn = carousel.querySelector('[data-deals-prev]');
      var nextBtn = carousel.querySelector('[data-deals-next]');
      if (!track || !prevBtn || !nextBtn) return;

      function getStep() {
        var firstSlide = track.querySelector('.hh-deals-slide');
        if (!firstSlide) return track.clientWidth;
        var slideWidth = firstSlide.getBoundingClientRect().width;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        return slideWidth + gap;
      }

      function updateArrows() {
        var maxScrollLeft = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft >= (maxScrollLeft - 2);
      }

      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  }

  function initPredictiveSearch() {
    var drawer = document.querySelector('[data-search-modal]');
    if (!drawer) return;

    var searchInput = drawer.querySelector('[data-search-input]');
    var searchResults = drawer.querySelector('[data-search-results]');
    var searchStatus = drawer.querySelector('[data-search-status]');
    var viewAllLink = drawer.querySelector('[data-search-view-all]');
    var searchForm = drawer.querySelector('[data-search-form]');
    if (!searchInput || !searchResults || !searchStatus || !viewAllLink) return;

    var debounceTimer = null;
    var activeController = null;
    var lastTerm = '';

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function formatMoney(value) {
      var amount = Number(value);
      if (!isFinite(amount)) return '';
      try {
        var formatted = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(amount);
        return formatted.replace(/\.00\b/, '');
      } catch (e) {
        return 'Rs. ' + amount.toFixed(2).replace(/\.00$/, '');
      }
    }

    function getImageUrl(item) {
      if (!item) return '';
      var featured = item.featured_image || item.image;
      if (!featured) return '';
      if (typeof featured === 'string') return featured;
      if (featured.url) return featured.url;
      return '';
    }

    function renderProducts(products) {
      if (!products || !products.length) return '';
      var rows = products.map(function (product) {
        var imageUrl = getImageUrl(product);
        var title = escapeHtml(product.title || 'Product');
        var url = escapeHtml(product.url || '#');
        var priceText = product.price != null ? formatMoney(product.price) : '';
        var compareText = '';
        if (product.compare_at_price && Number(product.compare_at_price) > Number(product.price || 0)) {
          compareText = '<span class="search-result-compare">' + escapeHtml(formatMoney(product.compare_at_price)) + '</span>';
        }
        var media = '';
        if (imageUrl) {
          media = '<span class="search-result-media"><img src="' + escapeHtml(imageUrl) + '" alt="' + title + '" loading="lazy"></span>';
        }
        var meta = '';
        if (priceText) {
          meta = '<div class="search-result-meta"><span class="search-result-price">' + escapeHtml(priceText) + '</span>' + compareText + '</div>';
        }
        return '<li><a class="search-result-item" href="' + url + '">' + media + '<span class="search-result-body"><span class="search-result-title">' + title + '</span>' + meta + '</span></a></li>';
      }).join('');
      return '<section><h4 class="search-result-group-title">Products</h4><ul class="search-result-list">' + rows + '</ul></section>';
    }

    function renderLinks(items, heading) {
      if (!items || !items.length) return '';
      var rows = items.map(function (item) {
        var title = escapeHtml(item.title || '');
        var url = escapeHtml(item.url || '#');
        return '<li><a href="' + url + '">' + title + '</a></li>';
      }).join('');
      return '<section><h4 class="search-result-group-title">' + heading + '</h4><ul class="search-link-list">' + rows + '</ul></section>';
    }

    function resetResults(message) {
      searchResults.hidden = true;
      searchResults.innerHTML = '';
      searchStatus.hidden = false;
      searchStatus.textContent = message || 'Start typing to see results';
    }

    function setViewAll(term) {
      var targetHref = (searchForm && searchForm.getAttribute('action')) ? searchForm.getAttribute('action') : '/search';
      if (term) targetHref += '?q=' + encodeURIComponent(term);
      viewAllLink.setAttribute('href', targetHref);
      viewAllLink.hidden = !term;
    }

    async function fetchPredictiveResults(term) {
      if (activeController) activeController.abort();
      activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'product,collection,page,article');
      params.set('resources[limit]', '6');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,variants.title,vendor');
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      var url = root + 'search/suggest.json?' + params.toString();

      var res = await fetch(url, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
        signal: activeController ? activeController.signal : undefined
      });

      if (!res.ok) throw new Error('Predictive search failed');
      return res.json();
    }

    async function runSearch(term) {
      var normalizedTerm = String(term || '').trim();
      setViewAll(normalizedTerm);

      if (normalizedTerm.length < 2) {
        resetResults(normalizedTerm.length ? 'Type at least 2 letters' : 'Start typing to see results');
        return;
      }

      searchStatus.hidden = false;
      searchStatus.textContent = 'Searching...';
      searchResults.hidden = true;

      try {
        var data = await fetchPredictiveResults(normalizedTerm);
        if (normalizedTerm !== lastTerm) return;

        var resources = data && data.resources && data.resources.results ? data.resources.results : {};
        var products = Array.isArray(resources.products) ? resources.products : [];
        var collections = Array.isArray(resources.collections) ? resources.collections : [];
        var pages = Array.isArray(resources.pages) ? resources.pages : [];
        var articles = Array.isArray(resources.articles) ? resources.articles : [];

        var markup = '';
        markup += renderProducts(products);
        markup += renderLinks(collections, 'Collections');
        markup += renderLinks(pages, 'Pages');
        markup += renderLinks(articles, 'Articles');

        if (!markup) {
          resetResults('No results found');
          return;
        }

        searchResults.innerHTML = markup;
        searchResults.hidden = false;
        searchStatus.hidden = true;
      } catch (e) {
        if (e && e.name === 'AbortError') return;
        resetResults('Could not load results');
      }
    }

    searchInput.addEventListener('input', function () {
      var value = searchInput.value || '';
      lastTerm = String(value).trim();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        runSearch(lastTerm);
      }, 220);
    });

    if (searchForm) {
      searchForm.addEventListener('submit', function () {
        setViewAll(searchInput.value || '');
      });
    }

    resetResults('Start typing to see results');
    setViewAll('');
  }

  function initNav() {
    var navEl = document.getElementById('nav');
    var overlay = document.querySelector('[data-overlay]');
    var search = document.querySelector('[data-search-modal]');
    var cart = document.querySelector('[data-cart-drawer]');
    var mobileGroups = document.querySelectorAll('.mobile-menu-group');

    function closeMobileSubmenus() {
      mobileGroups.forEach(function (group) {
        group.classList.remove('open');
        var toggleBtn = group.querySelector('[data-mobile-submenu-toggle]');
        if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      });
    }

    function setScrolled() {
      if (navEl) navEl.classList.toggle('scrolled', window.scrollY > 50);
      var topBtn = document.querySelector('[data-scroll-top]');
      if (topBtn) topBtn.classList.toggle('visible', window.scrollY > 400);
    }

    window.addEventListener('scroll', setScrolled);
    setScrolled();

    var menuBtn = document.querySelector('[data-menu]');
    if (menuBtn && navEl) {
      menuBtn.addEventListener('click', function () {
        var isOpen = navEl.classList.toggle('menu-open');
        if (!isOpen) closeMobileSubmenus();
      });
    }

    document.querySelectorAll('[data-mobile-submenu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.mobile-menu-group');
        if (!group) return;
        var isOpen = group.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    var searchBtn = document.querySelector('[data-search]');
    if (searchBtn) {
      searchBtn.addEventListener('click', function () {
        if (overlay) overlay.classList.add('open');
        if (search) {
          search.classList.add('open');
          var searchInput = search.querySelector('[data-search-input]');
          if (searchInput) setTimeout(function () { searchInput.focus(); }, 20);
        }
      });
    }

    var cartBtn = document.querySelector('[data-cart]');
    if (cartBtn) {
      cartBtn.addEventListener('click', function () {
        if (overlay) overlay.classList.add('open');
        if (cart) cart.classList.add('open');
      });
    }

    var closeCart = document.querySelector('[data-close-cart]');
    if (closeCart) closeCart.addEventListener('click', function () { closeOverlay(overlay, search, cart); });
    var closeSearch = document.querySelector('[data-close-search]');
    if (closeSearch) closeSearch.addEventListener('click', function () { closeOverlay(overlay, search, cart); });
    if (overlay) overlay.addEventListener('click', function () { closeOverlay(overlay, search, cart); });

    var topBtn = document.querySelector('[data-scroll-top]');
    if (topBtn) {
      topBtn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initPredictiveSearch();
    initFaq();
    initGallery();
    initShare();
    initQty();
    initCartDrawer();
    initReviewForm();
    initProductTabs();
    initDealsCarousel();
    initCountdown();
  });
})();

